export const COPY_FORM_ELEMENTS = 'fulcrum/containers/ProductOverview/COPY_FORM_ELEMENTS'
